import React, { useState } from 'react'
import { Dropdown, Menu, notification, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { vendorApprovalStatus } from 'Util/constants';
import { useMutation, useQuery } from '@apollo/client';
import { UPDATE_ADMIN_APPROVAL, UPDATE_DRIVERS } from 'Util/mutations';
import _ from 'lodash'
import { GET_DRIVER } from 'Util/queries';
import User from 'Hooks/user';


function DriverCardApproveActions({ ids }) {

    const [lbl, setLbl] = useState("Pending")

    const { user_id } = User()

    const [driver, setDriver] = useState(null)

    useQuery(GET_DRIVER, {
        variables: { where: { id: { _eq: ids.user_id } } },
        onCompleted(data) {
            data.drivers && setDriver(data.drivers[0])
        }
    })

    const [updateDriver] = useMutation(UPDATE_DRIVERS)

    const [update] = useMutation(UPDATE_ADMIN_APPROVAL, {
        onCompleted() {
            notification.success({
                message: "Status updated!"
            })
        }
    })

    const onAction = async (status) => {

        await update({
            variables: {
                where: { id: { _eq: ids.request_id } },
                _set: { status: status === 'verified' ? 'approved' : status, approver_id: user_id }
            }
        })

        if (status === 'verified') {
            updateDriver({
                variables: {
                    where: { id: { _eq: ids.user_id } },
                    _set: { status: 'verified' }
                }
            })
        }

        if (['rejected', 'blocked'].includes(status)) {
            updateDriver({
                variables: {
                    where: { id: { _eq: ids.user_id } },
                    _set: { status }
                }
            })
        }

        const res = _.find(vendorApprovalStatus, ['value', status])
        setLbl(res.label)
    }

    const menu = (
        <Menu>
            {vendorApprovalStatus.map(v => (
                <Menu.Item key={v.value} onClick={() => onAction(v.value)}>{v.label}</Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
            <a onClick={(e) => e.preventDefault()}>
                <Space>{lbl} <DownOutlined /></Space>
            </a>
        </Dropdown>
    )
}

export default DriverCardApproveActions
